
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import moment from 'moment';
import DatePickerDialog from '@/components/DatePickerDialog.vue';

moment.locale('it');

@Component({
  components: {
    DatePickerDialog,
  },
})
export default class DateFieldWithConfirm extends Vue {
  @Prop(String) readonly value: Date | null | undefined
  @Prop(Boolean) readonly confirmed!: boolean
  @Prop(String) readonly label: string | null | undefined
  @Prop(Boolean) readonly readonly: boolean | undefined
  @Prop(Boolean) readonly disabled: boolean | undefined
  @Prop(Array) readonly rules!: ((unknown) => string | boolean)[]
  @Prop(String) readonly appendIcon: string | null | undefined
  @Prop(String) readonly hint: string | null | undefined

  confirmDate: Date | null | undefined = null
  isConfirmed = false

  datePickerDialog = false
  datePickerDate: string | null = null
  datePickerName: string | null = null

  mDate(date: Date | null | undefined): string | null { return date ? moment(date).format('L') : null; }

  created() {
    console.log(`${this.constructor.name}: created()`); // eslint-disable-line no-console
    this.confirmDate = this.value;
    this.isConfirmed = this.confirmed;
  }

  @Watch('isConfirmed')
  onIsConfirmedChange(val: boolean) {
    if (this.confirmed !== val) {
      console.log(`${this.constructor.name}: onIsConfirmedChange(${val})`); // eslint-disable-line no-console
      this.$emit('confirm', val);
    } else {
      console.log(`${this.constructor.name}: onIsConfirmedChange(${val}) ignorato`); // eslint-disable-line no-console
    }
  }

  get isValid(): boolean | string {
    if (!this.rules) return true;

    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < this.rules.length; i++) {
      const result = this.rules[i](this.value);
      if (result !== true) return result;
    }

    return true;
  }

  @Watch('isValid')
  onIsValidChange(val: boolean | string) {
    console.log(`${this.constructor.name}: onIsValidChange(${val})`); // eslint-disable-line no-console
    if (val !== true && this.isConfirmed === true) {
      this.isConfirmed = false;
    }
  }

  onClickDate(name: string) {
    console.log(`${this.constructor.name}: onClickDate(${name})`); // eslint-disable-line no-console

    // Disattivo il campo
    if (this.readonly || this.disabled) return;

    // Imposta per quale campo verrà utilizzato il DatePicker
    this.datePickerName = name;

    // Imposta l'eventuale data precedentemente selezionata
    this.datePickerDate = this[name]
      ? moment(this[name]).toISOString(true).substring(0, 10)
      : null;

    // Apre il dialog per la selezione della data
    this.datePickerDialog = true;
  }

  onSelectDate(date: string | null) {
    console.log(`${this.constructor.name}: onSelectDate() date =`, date); // eslint-disable-line no-console

    if (!this.datePickerName) return;

    // Chiudo il dialog per la selezione della data
    this.datePickerDialog = false;

    const selectedDate = date
      ? moment(date, 'YYYY-MM-DD').toString()
      : null;

    // Inserisco la data nel modulo e nell'aggiornamento
    if (this.datePickerName in this) {
      this[this.datePickerName] = selectedDate;
    }

    // Modifico eventuali campi collegati
    switch (this.datePickerName) {
      default:
        break;
    }

    // Emetti evento input con la nuova data
    this.$emit('input', selectedDate);
  }

  onClearDate(name: string) {
    console.log(`${this.constructor.name}: onClearDate(${name})`); // eslint-disable-line no-console

    // Disattivo il campo
    if (this.readonly || this.disabled) return;

    // Cancello la data nel modulo e nel prossimo aggiornamento
    if (name in this) {
      this[name] = null;
    }

    // Modifico eventuali campi collegati
    switch (name) {
      default:
        break;
    }

    // Emetti evento input con la nuova data
    this.$emit('input', null);
  }

  get lineClass(): string {
    return this.isConfirmed ? 'selected' : '';
  }

  get lineIcon(): string | null {
    if (this.appendIcon) return this.appendIcon;
    return null;
    // return this.isConfirmed ? 'mdi-check-decagram' : null;
  }

  get tooltipText(): string {
    if (this.isValid === true) {
      return this.isConfirmed ? 'Confermato' : 'Premi per confermare';
    }

    return 'Non confermato';
  }
}

